import { jsxs as n, jsx as o } from "react/jsx-runtime";
const t = ({ className: r }) => /* @__PURE__ */ n(
  "svg",
  {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9.99984 12.8611L9.99984 4.52777M9.99984 12.8611C9.41631 12.8611 8.32611 11.1992 7.9165 10.7778M9.99984 12.8611C10.5834 12.8611 11.6736 11.1992 12.0832 10.7778",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M16.6668 14.5278C16.6668 16.5961 16.2352 17.0278 14.1668 17.0278H5.8335C3.76516 17.0278 3.3335 16.5961 3.3335 14.5278",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  t as DownloadIcon
};
